// extracted by mini-css-extract-plugin
export default {"text__area":"specificStyle_text__area__rvwkX","parents__dropdown":"specificStyle_parents__dropdown__ySBEx","text__area__label":"specificStyle_text__area__label__tj8Cx"};